// @flow

// Vendors
import React, { useState } from 'react';
import classnames from 'classnames';

// Types
import { NoticeType } from '../../types';

const Notice = ({
  type,
  message,
  dismiss,
  className,
  ...props
}: NoticeType) => (
  <div
    className={classnames(`notice notice--${type}`, className)}
    {...props}
    role="alert"
  >
    {dismiss && (
      <button
        type="button"
        className="notice__close"
        data-notice-close
        aria-label="Close"
        onClick={dismiss}
      />
    )}
    <div dangerouslySetInnerHTML={{ __html: message }} />
  </div>
);

export default Notice;
